import { glassboxImplementation } from './glassbox-implementation.js';

/**
 * @typedef Implementation
 * @interface
 * @property {string} id
 * @property {() => Promise} available
 * @property {({key:string, value:string}) => void} send
 */

/** @type {Implementation[]} */
const implementations = [glassboxImplementation];

class RefiBusinessInsights {
  get _implementations() {
    return implementations;
  }

  send({ key, value }) {
    const calls = this._implementations.map(async imp => {
      if (await imp.available()) {
        imp.send({ key, value });
      }
    });

    return Promise.all(calls);
  }
}

export { RefiBusinessInsights };
